import { apiClient } from '../config'

import { featureUpdate, type FeatureSettings } from './feature-rules'

export { featureKeys, supportsFeature } from './feature-rules'
export type { FeatureKey, FeatureRule, FeatureSettings, Platform } from './feature-rules'
export const featureSettingsService = {
  async get(): Promise<FeatureSettings> { return (await apiClient.get<FeatureSettings>('/admin/settings/features')).data },
  async save(settings: FeatureSettings, reason: string): Promise<FeatureSettings> {
    return (await apiClient.put<FeatureSettings>('/admin/settings/features', featureUpdate(settings, reason))).data
  },
}
